import { render, staticRenderFns } from "./CheckupDetailsModal.vue?vue&type=template&id=4e4b8c32&scoped=true&"
import script from "./CheckupDetailsModal.vue?vue&type=script&lang=js&"
export * from "./CheckupDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4b8c32",
  null
  
)

export default component.exports